import { Button, CircularProgress, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from '@mui/styles';
import TextField from "../UI/TextField";

const useStyles = makeStyles({
  closeIcon: {
    cursor: "pointer",
  },
  loadingIconBtn: {
    marginRight: "15px",
  },
});

const LocalForm = ({
  setLocal,
  local,
  clickSubmit,
  handleRemove,
  isLoadingAction,
}) => {
  const classes = useStyles();

  const onChange = (event) => {
    setLocal({
      ...local,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Grid container spacing={3} direction="column">
      <Grid>
        <CloseIcon
          onClick={() => setLocal(null)}
          className={classes.closeIcon}
        />
      </Grid>
      <Grid>
        <form onSubmit={clickSubmit}>
          <Grid container direction="column" spacing={2}>
            <Grid size={4}>
              <TextField
                label="Descrição"
                onChange={onChange}
                name="descricao"
                value={local.descricao ? local.descricao : ""}
              />
            </Grid>
            <Grid>
              <Grid container spacing={2} direction="row">
                <Grid>
                  <Button
                    variant="outlined"
                    type="submit"
                    disabled={isLoadingAction}
                  >
                    {isLoadingAction && (
                      <CircularProgress
                        className={classes.loadingIconBtn}
                        size={20}
                      />
                    )}
                    Salvar
                  </Button>
                </Grid>
                {!local.eNovo ? (
                  <Grid>
                    <Button
                      variant="outlined"
                      onClick={handleRemove}
                      disabled={isLoadingAction}
                    >
                      {isLoadingAction && (
                        <CircularProgress
                          className={classes.loadingIconBtn}
                          size={20}
                        />
                      )}
                      Deletar
                    </Button>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default LocalForm;
